import { SelectProps } from 'builder/components/Select/Select'
import { SelectValue } from 'builder/components/Select/types'
import { TooltipV2 } from 'builder/components/Tooltip/components/TooltipV2/TooltipV2'
import * as Styled from './styles'

export type Props = SelectProps<SelectValue> & {
  disabledTooltip?: string
}

export const CustomSelect = (props: Props) => {
  const { label, options, selected, onSelect, disabledTooltip, ...rest } = props

  return (
    <TooltipV2
      value={disabledTooltip}
      width={250}
      multiline={true}
      position="bottom"
      isActive={!!disabledTooltip && rest.disabled}
    >
      <Styled.SelectContainer>
        {label && <Styled.SelectLabel>{label}</Styled.SelectLabel>}
        <Styled.CustomSelect options={options} selected={selected} onSelect={onSelect} {...rest} />
      </Styled.SelectContainer>
    </TooltipV2>
  )
}
